function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { keyMap } from '@finect/front-utils/keyMap';
import { enableBodyScroll, disableBodyScroll } from '@finect/tabular-utils/bodyScrollLock';
import YouTube from 'react-youtube';
import { isBrowser } from '../commons/utils/isBrowser';
import { ModalOverlay, ModalBox, ModalContent } from './partials';
import { CloseAction } from './components';
var Info = styled.div.withConfig({
  displayName: "VideoModal__Info",
  componentId: "sc-1knbp3v-0"
})(["padding:8px 16px;margin-bottom:8px;"]);
var Title = styled.h3.withConfig({
  displayName: "VideoModal__Title",
  componentId: "sc-1knbp3v-1"
})(["font-weight:700;"]);
var Subtitle = styled.h4.withConfig({
  displayName: "VideoModal__Subtitle",
  componentId: "sc-1knbp3v-2"
})(["display:block;"]);
var VideoModalContent = styled(ModalContent).withConfig({
  displayName: "VideoModal__VideoModalContent",
  componentId: "sc-1knbp3v-3"
})(["padding-top:60px;border-radius:8px;background-color:", ";color:#fff;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiDDD;
});
export var VideoModal = function (_React$Component) {
  _inherits(VideoModal, _React$Component);
  var _super = _createSuper(VideoModal);
  function VideoModal() {
    var _this;
    _classCallCheck(this, VideoModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "target", void 0);
    _defineProperty(_assertThisInitialized(_this), "overlayNode", void 0);
    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
      if (event.keyCode === keyMap.ESCAPE) {
        _this.handleClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {});
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      if (typeof _this.props.onClose !== 'undefined') {
        _this.props.onClose();
      }
    });
    return _this;
  }
  _createClass(VideoModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isBrowser()) {
        document.addEventListener('mousedown', this.handleClick, false);
        document.addEventListener('keydown', this.handleKeydown, false);
        disableBodyScroll(this.target);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (isBrowser()) {
        document.removeEventListener('mousedown', this.handleClick, false);
        document.removeEventListener('keydown', this.handleKeydown, false);
        enableBodyScroll(this.target);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        video = _this$props.video,
        height = _this$props.height,
        width = _this$props.width;
      var fullScreen = this.props.fullScreen;
      return React.createElement(Fragment, null, React.createElement(ModalOverlay, {
        ref: function ref(node) {
          return _this2.overlayNode = node;
        }
      }, React.createElement(ModalBox, {
        ref: function ref(el) {
          return _this2.target = el;
        }
      }, React.createElement(VideoModalContent, {
        fullScreen: fullScreen
      }, React.createElement(CloseAction, {
        onAction: this.handleClose,
        color: "white"
      }), React.createElement(YouTube, {
        opts: {
          height: height || '510',
          width: width || '100%',
          playerVars: {
            autoplay: 1
          }
        },
        videoId: video.id
      }), React.createElement(Info, null, video.title ? React.createElement(Title, null, video.title) : '', video.subtitle ? React.createElement(Subtitle, null, video.subtitle) : '')))));
    }
  }]);
  return VideoModal;
}(React.Component);
_defineProperty(VideoModal, "defaultProps", {
  fullScreen: false
});